import { Component, OnInit } from '@angular/core';
import { Producto } from "../../../../models/Producto";
import { CategoriaService } from "../../../../services/categoria.service";
import { ProductoService } from "../../../../services/producto.service";
import { MarcaService } from 'src/app/services/marca.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GLOBAL } from "../../../../services/GLOBAL";
import { UserService } from 'src/app/services/user.service';

interface HtmlInputEvent extends Event{
  target : HTMLInputElement & EventTarget;
}

declare var jQuery:any;
declare var $:any;

@Component({
  selector: 'app-edit-producto',
  templateUrl: './edit-producto.component.html',
  styleUrls: ['./edit-producto.component.css']
})
export class EditProductoComponent implements OnInit {

  public file :File;
  public imgSelect : {poster: String | ArrayBuffer, hoverPoster: String | ArrayBuffer} = {poster: '', hoverPoster: ''};
  public producto : any = {};
  public msm_error;
  public msm_success;
  public config;
  public data_categorias : any = [];
  public data_marcas;
  public url;
  public id;
  public identity;

  constructor(
    private _categoriaService : CategoriaService,
    private _marcaService : MarcaService,
    private _productoService : ProductoService,
    private _route : ActivatedRoute,
    private _router : Router,
    private _userService: UserService,
  ) {
    this.identity = this._userService.getIdentity();
  }

  ngOnInit(): void {

    if(this.identity){
      if(this.identity.role == '12$MAhAAdPTi92gVknt8QyKIuEzcRYM6pa8.3RwTjFMfMwJvs2Jube'){
        this.url = GLOBAL.url;
        this._route.params.subscribe(
          params=>{
            this.id = params['id'];
            this._productoService.list_one(this.id).subscribe(
              response=>{
                this.producto = response.producto;
              },
              error=>{

              }
            )
          }
        );


        this._categoriaService.listar("").subscribe(
          response=>{
            response.categorias.forEach(element => {
              this.data_categorias.push({categoria : element.nombre,_id:element._id});

            });
          },
          error=>{

          }
        );

        this._marcaService.listar("").subscribe(
          response=>{
            this.data_marcas = response.marcas;
          },
          error =>{

          }
        );

        this.config = {
          height: 800,
          menubar: 'file edit view insert format tools table help',
          language : 'es',
          skin: 'material-classic',
          plugins: [
              'print preview fullpage paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons spellchecker mediaembed pageembed linkchecker powerpaste formatpainter casechange'
          ],
          toolbar:
          'casechange undo redo  bold italic underline strikethrough  fontselect fontsizeselect formatselect alignleft aligncenter alignright alignjustify outdent indent numlist bullist  forecolor backcolor removeformat pagebreak charmap emoticons fullscreen preview save print insertfile image media template link anchor codesample fullpage ltr rtl styleselect pageembed formatpainter',

        };
      }
      else{
        this._router.navigate(['/']);
      }
    }else{
      this._router.navigate(['/']);
    }


  }


  onSubmit(productoForm){
    if(productoForm.valid){

      let data = {
        _id:this.id,
        titulo : productoForm.value.titulo.trim(),
        poster : this.producto.poster,
        hoverPoster: this.producto.hoverPoster,
        precio_ahora : productoForm.value.precio_ahora,
        info_short : productoForm.value.info_short,
        categoria : productoForm.value.categoria,
        color : productoForm.value.color
      }

      this._productoService.update(data).subscribe(
        response =>{
          this._router.navigate(['/admin/productos']);
        },
        error=>{
          this.msm_error = 'Complete correctamente el formulario por favor.';
        }
      );
  }else{
    this.msm_error = 'Complete correctamente el formulario por favor.';
  }
  }

  imgSelected(event: HtmlInputEvent, fieldName){
    if(event.target.files  && event.target.files[0]){
        this.file = <File>event.target.files[0];

        const reader = new FileReader();
        reader.onload = e => this.imgSelect[fieldName]= reader.result;
        reader.readAsDataURL(this.file);
        this.producto[fieldName] = <File>event.target.files[0];

    }

  }

  close_alert(){
    this.msm_error = '';
    this.msm_success = '';
  }

}
